import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@commons/guards/authentication/authentication.guard';
import { canActivatePermission } from '@commons/permissions/services/permissions.service';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./authentication/splash/splash.component').then(
        (m) => m.SplashComponent,
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./authentication/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./authentication/sign-up/signup.component').then(
        (m) => m.SignupComponent,
      ),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./mainframe/mainframe.component').then(
        (m) => m.MainframeComponent,
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(
        (m) => m.DashboardViewComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'prep-log',
    loadComponent: () =>
      import('./dispatch/dispatch-log/dispatch-log.component').then(
        (m) => m.DispatchLogComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'drop-ship',
    loadComponent: () =>
      import('./drop-ship/drop-ship.component').then(
        (m) => m.DropShipComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'so-dispatcher',
    loadComponent: () =>
      import('./dispatch/so-dispatcher/so-dispatcher.component').then(
        (m) => m.SoDispatcherComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'assign-grades',
    loadComponent: () =>
      import('./grades/assign-grades/assign-grades.component').then(
        (m) => m.AssignGradesComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'serial-in',
    loadComponent: () =>
      import('./serial-in/serial-in.component').then(
        (m) => m.SerialInComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'po-summary',
    loadComponent: () =>
      import('./receiving/receive-po/receive-po.component').then(
        (m) => m.ReceivePoComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'receive-po',
    loadComponent: () =>
      import('./po-summary/po-summary.component').then(
        (m) => m.PoSummaryComponent,
      ),
    canActivate: [AuthenticationGuard, canActivatePermission],
  },
  {
    path: 'device-query-screen',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./device-query-screen/device-query-screen.component').then(
        (m) => m.DeviceQueryScreenComponent,
      ),
  },
  {
    path: 'device-audit',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./device-audit/device-audit.component').then(
        (m) => m.DeviceAuditComponent,
      ),
  },
  {
    path: 'item-locations',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./item-locations/item-locations.component').then(
        (m) => m.ItemLocationsComponent,
      ),
  },
  {
    path: 'location-prefixes',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./location-prefixes/location-prefixes.component').then(
        (m) => m.LocationPrefixesComponent,
      ),
  },
  {
    path: 'trade-in',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./trade-in/trade-in.component').then((m) => m.TradeInComponent),
    loadChildren: () =>
      import('./trade-in/trade-in.routes').then(
        (routes) => routes.TRADE_IN_ROUTES,
      ),
  },
  {
    path: 'dock-receipt',
    canActivate: [AuthenticationGuard],
    loadComponent: () =>
      import('./box-receipt/box-receipt.component').then(
        (m) => m.BoxReceiptComponent,
      ),
    loadChildren: () =>
      import('./box-receipt/box-receipt.routes').then(
        (routes) => routes.BOX_RECEIPT_ROUTES,
      ),
  },
  {
    path: 'category-mapping',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./category-mapping/category-mapping.component').then(
        (m) => m.CategoryMappingComponent,
      ),
    loadChildren: () =>
      import('./category-mapping/category-mapping.routes').then(
        (routes) => routes.CATEGORY_MAPPING_ROUTES,
      ),
  },
  {
    path: 'bid-management',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./bid/bid.component').then((m) => m.BidComponent),
    loadChildren: () =>
      import('./bid/bid.routes').then((routes) => routes.BID_ROUTES),
  },
  {
    path: 'lob',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./lob/lob.component').then((m) => m.LobComponent),
    loadChildren: () =>
      import('./lob/lob.routes').then((routes) => routes.LOB_ROUTES),
  },
  {
    path: 'ship-from-warehouse',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./ship-from-warehouse/ship-from-warehouse.component').then(
        (m) => m.ShipFromWarehouseComponent,
      ),
  },
  {
    path: 'file-upload',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./device-file-upload/device-file-upload.component').then(
        (m) => m.DeviceFileUploadComponent,
      ),
  },
  {
    path: 'reports',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./reports/reports.component').then((m) => m.ReportsComponent),
    loadChildren: () =>
      import('./reports/reports.routes').then(
        (routes) => routes.REPORTS_ROUTES,
      ),
  },
  {
    path: 'reports-designer',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./reports/reports-designer/reports-designer.component').then(
        (m) => m.ReportsDesignerComponent,
      ),
    loadChildren: () =>
      import('./reports/reports-designer/reports-designer.routes').then(
        (routes) => routes.REPORTS_DESIGNER_ROUTES,
      ),
  },
  {
    path: 'users',
    canActivate: [AuthenticationGuard, canActivatePermission],
    loadComponent: () =>
      import('./users/users.component').then((m) => m.UsersComponent),
    loadChildren: () =>
      import('./users/users.routes').then((routes) => routes.USERS_ROUTES),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./authentication/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
];
